import ApiService from './ApiService'

import HARDCODE from '../business-const/HardCode/HardCode'

import AuthService from './AuthService'



class ClienteExemploService extends ApiService {

    constructor() {
        super(HARDCODE.apiClienteExemplo)
    }

    buscarClienteExemploList(variaveisGlobais/*, idConfiguracao*/) {

        let params = `idUsuario=${AuthService.obterUsuarioLogado(variaveisGlobais)}`

        //params = `${params}&idConfiguracao=${idConfiguracao}`

        return this.get(variaveisGlobais, `${HARDCODE.apiClienteExemploBuscarClienteExemploList}/?${params}`, false)
    }
}

export default ClienteExemploService